// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__VYIiM","expireSoon":"styles_expireSoon__1kdrL"};